// Port NGUYÊN VĂN từ ra-log-monitor-cms/source/src/containers/log/parseFoodData.js.
// Không dọn code, không đổi tên biến — đây là bộ phân tích chuỗi món ăn, sai một ký tự là lệch tiền.
import { round } from "lodash";

var delim_1 = '¶*¶';
var delim_2 = '█';
var delim_3 = 'Ө';
var delim_4 = '≡';
var delim_5 = '≠';
var delim_6 = '------------------------------';

export function parserFood(monAnString,parent){
    //console.log(monAnString);
    //console.log(JSON.stringify(parent));
    
    var monAn = monAnString.split(delim_1);
    var kq = [];



    for (var i=0; i<monAn.length; i++) {
        if(monAn[i]!=='' && monAn[i]!== delim_6){
            try{
                var foodItem = {};
                //console.log("Mon an: "+monAn[i]);
                var itemCheck = monAn[i].split(delim_2);
                
                foodItem.type = 1;//mon an
                
                foodItem.typeString = itemCheck[0];
                //console.log(JSON.stringify(itemCheck))

                var foodElement = itemCheck[1].split(delim_3);
                var quantity = foodElement[0];
                foodItem.quantity = quantity;
                var name = foodElement[1];
                foodItem.name = name;
                var price = foodElement[2];
                foodItem.price = price;
                var tax = foodElement[3];
                foodItem.tax = tax;
                var percent = "";
                if (foodElement.length > 4){
                    percent = foodElement[4];
                }
                foodItem.percent = percent;

                


                foodItem.selected = 0;

                //tinh tien giam gia neu co
                if(foodItem.percent!=undefined && foodItem.percent.trim() !== ''){
                    var money = foodItem.price.replace(',','.');
                    money = money.replace(' ','');
                    money = money.replace('€','');
                    money = Math.round(parseFloat(money)*100);

                    // Bẫy I2: bản chép NGUYÊN VĂN khai `var percent` hai lần trong cùng hàm ->
                    // no-redeclare (mức error) chặn lint. Tắt lint tại chỗ, KHÔNG refactor.
                    // eslint-disable-next-line no-redeclare
                    var percent = foodItem.percent.replace(',','.').trim();
                    percent = parseFloat(percent);
                    money = round(money*((100.0-percent)/100.0),2) ;
                    foodItem.pricePercent = money;
                }


                kq.push(foodItem);

                var addtionFoods = [];
                if (foodElement.length > 5){
                    addtionFoods = foodElement[5].split(delim_4);
                }
                if(addtionFoods.length >0){
                    for(var j =0; j<addtionFoods.length; j++){
                        if(addtionFoods[j]!==''){
                            var addFoodObj = {};
                            var addFoodDetail = addtionFoods[j].split(delim_5);
                            addFoodObj.type = 2; //do an them
                            addFoodObj.name = addFoodDetail[0];
                            addFoodObj.tax = addFoodDetail[1];
                            addFoodObj.price = addFoodDetail[2];
                            if(addFoodDetail.length >3){
                                addFoodObj.beilage = 1;   
                            }
                            addFoodObj.quantity = quantity;
                            addFoodObj.allow = foodItem.allow;
                            addFoodObj.selected = 0;
                            kq.push(addFoodObj);
                        }

                    }
                }
            }catch(err){
                console.log("Catch err: "+JSON.stringify(err));
                console.log("+++++++++++=> chuoi mon an: "+monAnString);
                console.log("+++++++++++=> mon an bi loi: "+monAn[i]);

                break;
            }
        }
    }

    return kq;
}